var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.159,
    height: 18.159,
    viewBox: "0 0 18.159 18.159",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_play",
    "data-name": "vuesax/outline/play",
    transform: "translate(-492 -316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "play",
    transform: "translate(492 316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15518",
    "data-name": "Path 15518",
    d: "M6.271,3.131a21.847,21.847,0,0,1,4.284,2.04,26.624,26.624,0,0,1,3.916,3.17,6.078,6.078,0,0,1-2.277,3.465,30.763,30.763,0,0,1-5.922,3.417L3.66,12.615V5.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.079,12.709a2.853,2.853,0,0,1-1.466-.391A3.862,3.862,0,0,1,0,8.8V3.912A3.854,3.854,0,0,1,1.613.391,3.641,3.641,0,0,1,5.391.719L9.5,3.158a3.841,3.841,0,0,1,2.166,3.2A3.828,3.828,0,0,1,9.5,9.558L5.391,12A4.638,4.638,0,0,1,3.079,12.709Zm0-11.688a1.839,1.839,0,0,0-.966.253A2.9,2.9,0,0,0,1,3.912V8.79a2.9,2.9,0,0,0,1.113,2.638A2.715,2.715,0,0,0,4.892,11.1L9,8.66A2.861,2.861,0,0,0,10.67,6.351,2.861,2.861,0,0,0,9,4.042L4.892,1.6A3.669,3.669,0,0,0,3.079,1.021Z",
    transform: "translate(3.25 2.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H18.159V18.159H0Z",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.0745a6239623359ab71172794375f479.svg";
export { ForwardRef as ReactComponent };